import { ArticleThumbnail } from 'components/ArticleSummaries';
import { trackArticleClick } from 'lib/Tracking';
import { ArticleModel } from 'lib/Presenters/ArticleSummariesPresenter';
import featuredArticleSummariesCSS from './styles/FeaturedArticleSummaries';

interface Props {
  articleSummaries: ArticleModel[];
}

function FeaturedArticleSummaries({ articleSummaries }: Props): JSX.Element {
  const articles = articleSummaries.slice(0, 4);
  const [firstArticle, ...otherArticles] = articles;

  return (
    <div className="featured-article-summaries-container">
      <div className="large-article-pane">
        <ArticleThumbnail
          large={true}
          featured={true}
          {...firstArticle}
          onClick={trackArticleClick}
          engagementType={'featured_article_click'}
        />
      </div>
      <div className="small-articles-pane">
        {otherArticles.map((article) => (
          <ArticleThumbnail
            key={article.slug}
            featured={true}
            {...article}
            onClick={trackArticleClick}
            engagementType={'featured_article_click'}
          />
        ))}
      </div>
      <style jsx>{featuredArticleSummariesCSS}</style>
    </div>
  );
}

export default FeaturedArticleSummaries;
